import { createStore } from 'vuex';

export default createStore({
    state: {
        lang: 'ru',
        user: null
    },
    mutations: {
        updateLanguage(state, lang) {
            state.lang = lang
            console.log(state.lang)
        }
    },
    getters: {
        currentLanguage: state => state.lang,
    }
});
